var PARTNER_ROLE_PREFIX = {
  cover_link: ['COVERLINK', '/COVERLINK'],
  omk: ['/OMK'],
  accessbank: ['/ACCESSBANK', 'ACCESSBANK'],
  ktda: ['/KTDA', 'KTDA'],
};

/**
 * Filters a list of Keycloak role/group objects to only those matching
 * the given partner's prefix. If no prefix is configured for the partner,
 * the full list is returned unchanged.
 *
 * @param {Array} roles - Array of role objects with a `name` or `path` property
 * @param {string} partnerGuid - The partner GUID (e.g. 'omk', 'cover_link')
 * @returns {Array} Filtered roles
 */
export function filterRolesByPartner(roles, partnerGuid) {
  if (!roles) return [];
  var prefixes = PARTNER_ROLE_PREFIX[partnerGuid];
  if (!prefixes || prefixes.length === 0) return roles;
  return roles.filter(function(role) {
    var identifier = role.path || role.name || '';
    for (var i = 0; i < prefixes.length; i++) {
      if (identifier.startsWith(prefixes[i])) return true;
    }
    return false;
  });
}
